import React, { useContext, useEffect, useState } from 'react';
import AIG from "../../../assets/Logo/AIG";
import Automoby from "../../../assets/Logo/Automoby";
import Autonomo from "../../../assets/Logo/Autonomo";
import cl from './Register.module.css' 
import { Link } from 'react-router-dom'; 
import ErrorModal from '../ErrorModal/ErrorModal';
import OkModal from '../OkModal/OkModal';
import { baseFileURL } from '../../../Api';
import { AppContext } from '../../../providers/appProvider';
import { useNewUser } from '../../../hooks/useNewUser';

import Mobile from "../../../assets/Icon/Mobile";
import At from "../../../assets/Icon/At";
import Id from "../../../assets/Icon/Id"; 
import User from "../../../assets/Icon/User";
import Lock from "../../../assets/Icon/Lock";
import ContainerLogo from '../../../assets/Logo/ContainerLogo';

import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { useAuth } from '../../../providers/authProvider';
import { useTranslation } from 'react-i18next';
import Flag from '../../UI/Flag/Flag';

function Register() {
    const { t, i18n } = useTranslation();
    
    const newUserResetData = {
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        mobile: "",
        password:""
    }

    const [newNewUser, setNewNewUser] = useState(newUserResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})
    const {newUserService} = useNewUser(-1)
    const { appState, app } = useContext(AppContext);
    const auth = useAuth()


    const validateNewUser = (newUser) => {
        const messages = {};
    
        if (newUser.firstname.length < 2) {
            messages.firstname = { message: t('PleaseEnterFirstname'), isValid: false };
        }

        if (newUser.lastname.length < 2) {
            messages.lastname = { message: t('PleaseEnterLastname'), isValid: false };
        }

        if (newUser.personal.length < 1) {
            messages.personal = { message: t('Required'), isValid: false };
        }
 

        if (newUser.mobile.length < 12) {
            messages.mobile = { message: t('Phone12DigitsRequired'), isValid: false };
        }

        if (newUser.password.length < 6) {
            messages.password = { message: t('Password6CharsMinimum'), isValid: false };
        }

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!newUser.email || newUser.email.length === 0 || !emailRegex.test(newUser.email)) {
            messages.email = { message: t('InvalidEmail'), isValid: false };
        }
  
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateNewUser(newNewUser)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateNewUser(newNewUser)
        }
      }, [newNewUser, isFirstValidated]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateNewUser(newNewUser)

        if (isValidate === true) {
            newUserService.add(newNewUser)
            .then(response => {
                 auth.loginVia(response.data)
                 setIsModalOpen(false)
            })
            .catch(error => {
                console.error(error);
                if (error.response.data.message.includes("email")) {
                    app.setError(t('EmailAlreadyExists'));
                } else if (error.response.data.message.includes("mobile")) {
                    app.setError(t('MobileAlreadyExists'));
                } else {
                    app.setError(t('RegistrationError'));
                } 
            });
         } else {
            setIsFirstValidated(true) 
        } 
        
    };

    const handleNewUserChange = async (event) => {
        let val = event.target.value;
        setNewNewUser(prevNewUser => ({
            ...prevNewUser,
            [event.target.name]: val
        })); 
    };

    const handlePhoneChange = (phone) => {
        let val = phone;
        setNewNewUser(prevClient => ({
            ...prevClient,
            ["mobile"]: val
        }));
 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false)
        setNewNewUser(newUserResetData)
    }
  


    
    return <div className='themeCRM' data-theme="light" data-company={
            baseFileURL === 'https://i-logistics.net' || baseFileURL === 'https://dev.i-logistics.net' ? (
                'ilogistics'
            ) : baseFileURL === 'https://finance.automoby.ge' ? (
                'automoby'
            ): baseFileURL === 'https://crm.autonomo.kz' ? (
                'autonomo'
            ) : baseFileURL === 'https://crm.aig.com.ge' || baseFileURL === 'https://crmdev.aig.com.ge'   ? (
                'aig'
            ) : (
           'automoby'
        )} style={{ height: '100vh' }}>
        <div className={cl.bgLight} >
            <div className={cl.Page} >
                <div className={cl.Head} >

                    {baseFileURL === 'https://i-logistics.net' || baseFileURL === 'https://dev.i-logistics.net' ? (
                        <div className={cl.LogoContainer}>
                            <ContainerLogo  />
                            <span>i-Logistics</span>  
                        </div>
                    ) : baseFileURL === 'https://finance.automoby.ge' ? (
                        <Automoby /> 
                    ): baseFileURL === 'https://crm.autonomo.kz' ? (
                        <Autonomo/> 
                    ) : baseFileURL === 'https://crm.aig.com.ge' || baseFileURL === 'https://crmdev.aig.com.ge'  ? (
                        <AIG />
                    ) : (
                        <Automoby /> 
                    )}


                        <div className={cl.langlist}>
                                <span
                                className={i18n.language === 'ka' ? cl.langActive : ''}
                                onClick={() => i18n.changeLanguage('ka')}
                                >
                                <Flag countryCode={'ge'} />
                                </span>
                                <span
                                className={i18n.language === 'en' ? cl.langActive : ''}
                                onClick={() => i18n.changeLanguage('en')}
                                >
                                <Flag countryCode={'gb'} />
                                </span>
                                <span
                                className={i18n.language === 'ru' ? cl.langActive : ''}
                                onClick={() => i18n.changeLanguage('ru')}
                                >
                                <Flag countryCode={'ru'} />
                                </span>
                        </div>

                
                </div>
                <div className={cl.Box} >


                {appState.ok && <OkModal message={appState.ok} onClose={() => app.clearOk(false)} />}
                {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}


                    <h3 style={{ marginBottom: '20px' }}>{t('NewUser')}</h3>


                           
                    <div className={cl.inp2col}>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.firstname ? cl.input + ' ' + cl.errorInput : cl.input}
                                    placeholder={t('Firstname')} name="firstname" value={newNewUser.firstname} onChange={handleNewUserChange} autoComplete="off" 
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '').toUpperCase();
                                    }}
                                    />
                                <div className={cl.crmIcon}>
                                    <User />
                                </div>
                            </div>
                        </div>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.lastname ? cl.input + ' ' + cl.errorInput : cl.input}
                                    placeholder={t('Lastname')} name="lastname" value={newNewUser.lastname} onChange={handleNewUserChange} autoComplete="off"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '').toUpperCase();
                                    }}
                                    />
                                <div className={cl.crmIcon}>
                                    <User />
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.personal ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder={t('PersonalNumber')}  name="personal" value={newNewUser.personal} onChange={handleNewUserChange} autoComplete="off"
                                onInput={(e) => {
 
                                    if (e.target.value.length > 11) { 
                                        e.target.value = e.target.value.substring(0, 11);
                                    }
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
    
                                }}
                                />
                            <div className={cl.crmIcon}>
                                <Id />
                            </div>
                        </div>
                        {validates && validates.personal &&
                            <div className={cl.errorMsg} >{validates.personal.message}</div>}
                    </div>


 

                    <div className={cl.inp2col1} style={{ marginBottom: 0 }}>
                            <div className={validates && validates.mobile ? cl.groupInput + ' errorInput'  : cl.groupInput}>
                            <PhoneInput
                                defaultCountry={baseFileURL === 'https://crm.autonomo.kz' ? 'kz' : 'ge'}
                                value={newNewUser.mobile}
                                defaultMask="... ...-..."
                                hideDropdown={false}
                                name="mobile"  
                                onChange={(phone) => handlePhoneChange(phone)}
                            />
                         
                             {validates && validates.mobile &&
                                <div className={cl.errorMsg} >{validates.mobile.message}</div>}

                        </div>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.email ? cl.input + ' ' + cl.errorInput : cl.input}
                                    placeholder={t('Email')}  name="email" value={newNewUser.email} onChange={handleNewUserChange} autoComplete="off"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9.@\-_]/g, '').toUpperCase();
                                    }}
                                    />
                                <div className={cl.crmIcon}><At /></div>
                            </div>
                            {validates && validates.email &&
                                <div className={cl.errorMsg} >{validates.email.message}</div>}
                        </div>
    
                    </div>


 
                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS" className={validates && validates.password ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder={t('Password')} name="password" value={newNewUser.password} onChange={handleNewUserChange} autoComplete="off" />
                            <div className={cl.crmIcon}><Lock /></div>
                        </div>
                        {validates && validates.password &&
                            <div className={cl.errorMsg} >{validates.password.message}</div>}
                    </div>



                    <span onClick={saveHandle} style={{ marginBottom: '10px' }} className={cl.btnPrimary}>{t('Register')}</span> 

 
                    <Link to="/login" className={  cl.AddBtn } >{t('Authorization')} </Link>

 


                </div>
            </div>
        </div>  
    </div> ;
}

export default Register;
